import Cookies from 'js-cookie'
import { COOKIE_NAME_AGREED_COOKIES } from '@/constants'
import { h } from 'vue'

export const checkConsentMixin = {
  props: {
    requireConsent: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  created() {
    new Promise((resolve) => {
      if (!this.requireConsent || Cookies.get(COOKIE_NAME_AGREED_COOKIES) === 'all') {
        resolve(true)
      }
      document.addEventListener(COOKIE_NAME_AGREED_COOKIES, () => {
        resolve(true)
      })
    }).then(this.trackPage)
  },

  render() {
    // render-less view function just returns an empty string.
    return h('')
  }
}
